import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeCourt } from '../../../shared/models/jobTypeCourt.model';

// import { CreateJobTypeComponent} from './create-job-type.component';

import { BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map, Subscription} from 'rxjs';
import { JobTypeLocation } from '../../../shared/models/jobTypeLocation.model';
import { JobType } from '../../../shared/models/jobType.model';
import { JobStatus } from 'src/app/shared/models/jobStatus.model';


@Component({
  selector: 'app-update-job-status-widget',
  templateUrl: './update-job-status-widget.component.html',
  styleUrls: ['./update-job-status-widget.component.scss']
})
export class UpdateJobStatusWidgetComponent implements OnInit {

  model: any;
  job_types: Object;
  job_type_locations: Object;
  count2: any;
  get_latest_court_id: Object;
  job_type_court: Object;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  // sees if there is a change in myCount
@Output()
change: EventEmitter<number> = new EventEmitter<number>();
  job_type: any;
  job_type_location: any;


  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  job_status: any;

  constructor(
  private http: HttpClient,
  private _demoService: DemoService,
  private route: ActivatedRoute,
  private router: Router,
  public toastr: HotToastService,
  vcr: ViewContainerRef,
  private modalService: BsModalService, viewRef: ViewContainerRef) { }


  
  ngOnChanges() {
    this.change.emit(this.intialCount);
   // this.getTraceCandidate(this.count);
   this.model = new JobStatus();
  //  this.model = this.getJobStatusDetails(this.count);
   this.getJobStatusDetailsById(this.count);


  }

  ngOnInit() {
  }


  getJobStatusDetailsById(job_status_id) {
    this._demoService.getJobStatusDetailsByID(job_status_id).subscribe(
       data => { 
        this.job_status = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   updateJobType(model) {
    this._demoService.updateJobType(model).subscribe(
       data => {
       // console.log(model);
         // this.trace_candidate_update = data;
       this.toastr.success('Job Type Updated');
        // run a function in parent component
       this.closeParentModel.emit();
       
       // Subject to reload the manager component parent.
// CreateJobTypeComponent.returned.next(false);
         return true;
       },
       error => {
         console.error('Error saving Job Type!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
    );
    }


    updateJobStatus(model) {
      this._demoService.updateJobStatus(model).subscribe(
         data => {
         // console.log(model);
           // this.trace_candidate_update = data;
         this.toastr.success('Job Status Updated');
          // run a function in parent component
         this.closeParentModel.emit();
         
         // Subject to reload the manager component parent.
  // CreateJobTypeComponent.returned.next(false);
           return true;
         },
         error => {
           console.error('Error saving Job Status!');
          return console.log(error);
         }
        // err => console.error(err),
        // () => console.log('done updates')
      );
      }



}
